import classes from "./textarea.module.scss";

interface Props<T, K extends keyof T> {
  name?: string;
  label: string;
  placeholder?: string;
  identifier: K;
  onChange: (identifier: K, value: string) => void;
  isValid?: boolean;
  error?: boolean;
  required?: boolean;
}

const TextArea = <T, K extends keyof T>({
  onChange,
  identifier,
  label,
  placeholder,
  isValid,
  error,
  name,
}: Props<T, K>) => {
  return (
    <div>
      <p
        style={{
          width: "fit-content",
        }}
      >
        {label}
      </p>
      <div className={classes.visible}>
        <textarea
          onChange={(event) => {
            onChange(identifier, event.target.value);
          }}
          name={name}
          placeholder={placeholder}
          className={`${classes.input} ${
            !isValid && error ? classes.error : !isValid && classes.error
          }`}
        />
      </div>
    </div>
  );
};

export default TextArea;
